import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { AccountInformationWrapper } from "../../components";

export default function AccountInformationPage() {
  return (
    <PaginationProvider>
      <ModalProvider>
        <AccountInformationWrapper />
      </ModalProvider>
    </PaginationProvider>
  );
}
